import * as React from "react"
import { Box, Grid } from "@mui/material"
import { ImageSeeker } from "@ui-seeker/core"

import { AutocompleteAsyncSeeker } from "@ui-seeker/core"

import { DIPBrandCustomer } from "@components"
import { BACKEND_APIS, USER_ROLES } from "@constants"
import { useBuildExternalURL, useUserApp } from "@hooks"
import { brandForm, catalogueDetailsErrorFormData, siteForm, skuForm } from "../@signals"


export default function CatalogueDetailsFormDrawerContent() {
    const { userRole } = useUserApp()
    const { imageURL } = useBuildExternalURL({
        imageData: { skuID: skuForm.value }
    })

    const brandHelperText = (!brandForm.value && skuForm.value)
        ? "Please select a brand if you have a SKU selected."
        : "Leave the field empty if you don't want to associate the product with any brand.";

    const myProps = {
        brand: { grid: { xs: 12 }, multiple: false, helperText: brandHelperText },
        sku: { grid: { xs: 12 }, multiple: false, helperText: "Leave the field empty if you don't want to associate the product with any sku." }
    }

    return <Grid container spacing={2}>
        <Grid item {...myProps?.brand?.grid}>
            <DIPBrandCustomer
                error={catalogueDetailsErrorFormData.value?.brand}
                label="Brand"
                placeholder="Search Brand..."
                value={brandForm.value}
                onChange={e => {
                    brandForm.value = e.target.value
                }}
                {...myProps?.brand}
            />
        </Grid>

        <Grid item {...myProps?.sku?.grid}>
            <AutocompleteAsyncSeeker
                urlAjax={userRole === USER_ROLES.RETAILER ? `${BACKEND_APIS.MASTER_DATA}/sku/retailer-find` : `${BACKEND_APIS.MASTER_DATA}/sku/find`}
                error={catalogueDetailsErrorFormData.value?.sku}
                filters={{
                    brand: brandForm.value, retailer: siteForm.value.siteID, country: siteForm.value.siteCountry
                }}
                label="SKU"
                placeholder="Search SKU..."
                value={skuForm.value || null}
                limitTags={4}
                onChange={e => {
                    skuForm.value = e.target.value
                }}
                {...myProps?.sku}
            />
        </Grid>

        {!!skuForm.value && <Box sx={{ margin: 1 }}>
            <ImageSeeker src={imageURL} height="auto" width="250px"/>
        </Box>}
    </Grid>
}